/**
 * Decides the bwip-js symbology for a product number value.
 *
 * ISMN numbers are drawn from the EAN-13 `979-0` range (GS1 prefix `9790`),
 * everything else is an ISBN. Any non-digit characters (dashes, the leading
 * "ISBN "/"ISMN " agency label, spaces) are ignored before the prefix check.
 *
 * @param value the raw or formatted product number (e.g. `9790260000438`,
 *   `979-0-2600-0043-8`, or `ISMN 979-0-...`)
 * @returns `"ismn"` when the number is an ISMN, otherwise `"isbn"`
 */
export var detectSymbology = function (value) {
    var digits = (value || "").replace(/\D/g, "");
    return digits.startsWith("9790") ? "ismn" : "isbn";
};
/**
 * Picks the text bwip-js should encode for a product number.
 *
 * The formatted value (with dashes, e.g. `978-80-52132-01-2`) is preferred so
 * that bwip-js can validate the grouping and render the same hyphenation; the
 * plain value is a fallback.
 *
 * @param productNumber the product number to render
 * @returns the string to pass to bwip-js as `text`, or an empty string when the
 *   product number carries no value
 */
export var barcodeTextForNumber = function (productNumber) {
    return productNumber.formattedValue || productNumber.value || "";
};
/**
 * Builds a download file name for a generated barcode.
 *
 * @param productNumber the product number the barcode was generated from
 * @param ext the file extension without a dot (e.g. `svg`, `eps`, `pdf`, `png`)
 * @returns a sanitised file name such as `barcode-978-80-52132-01-2.svg`
 */
export var barcodeFilename = function (productNumber, ext) {
    var raw = productNumber.formattedValue ||
        productNumber.value ||
        productNumber.id ||
        "barcode";
    var safe = raw.replace(/[^0-9A-Za-z-]/g, "");
    return "barcode-".concat(safe, ".").concat(ext);
};
